import React, { useState } from 'react'
import Modal from '../Modal/Modal';
import data from '../../data.json'
import './Hero.css'
const Hero = () => {

    const coins = data;

    const [modal, setModal] = useState(false)
    const [cname, setCname] = useState('default')
    const [icon, setIcon] = useState('default')
    const [avbal, setAvbal] = useState('0.000')
    const [mystakes, setMystakes] = useState('0%')
    const [earnings, setEarnings] = useState('0.000')

    async function showmodal(name) {
        setModal(!modal)
        let coin= await coins.find(item => item.Name === name);
        setCname(coin.Name)
        setIcon(coin.Icon)
        setMystakes(coin.MyStakes)
        setAvbal('0.000')        // should be loaded from api directly
        setEarnings(coin.Earnings)
    }
    return (
        <div className="Hero">
            <Modal trigger={modal} showmodal={showmodal} cname={cname} icon={icon} avbal={avbal} mystakes={mystakes} earnings={earnings} />
            <div className="HeroDetails">
                <div className="quote-heading">we relay on maths not validators</div>
                <div className="heading">
                    Deploy your crypto into DeFi.
                </div>

                <div className="paragraph">
                    Earn a yield, Multiply your exposure or Borrow against your crypto. BNB, BSCDAO and 14  more cryptos are available to put to work.
                </div>
                <a href="/" className='button btn1'>
                    <span>Connect Wallet</span>
                    <img className="arrow" src="/arrow.svg" alt="" />
                </a>
            </div>

            <div className="BTC-ETH-COIN">
                <div className="coin-frame" onClick={() => { showmodal('BNB') }}>
                    <div className="inner-frame">
                        <img src="/bnb.png" alt="" />
                        <span className="coin-text">
                            BNB
                        </span>
                    </div>
                </div>

                <div className="coin-frame" onClick={() => { showmodal('ETH') }}>
                    <div className="inner-frame">
                        <img src="/weth.png" alt="" />
                        <span className="coin-text">
                            ETH
                        </span>
                    </div>
                </div>


                <div className="coin-frame" onClick={() => { showmodal('BSCDAO') }}>
                    <div className="inner-frame">
                        <img src="/bscdao.png" alt="" />
                        <span className="coin-text">
                            BSCDAO
                        </span>
                    </div>
                </div>


                <div className="coin-frame" onClick={() => { showmodal('DAI') }}>
                    <div className="inner-frame">
                        <img src="/dai.png" alt="" />
                        <span className="coin-text">
                            DAI
                        </span>
                    </div>
                </div>


                <div className="coin-frame" onClick={() => { showmodal('WXRP') }}>
                    <div className="inner-frame">
                        <img src="/wxrr.png" alt="" />
                        <span className="coin-text">
                            WXRP
                        </span>
                    </div>
                </div>


            </div>
        </div>
    )
}

export default Hero